import { IInstitutionListResponse, ISuccessResponseType } from "../../constants/commonTypes";
import * as uploadDocumentActions from "../actionTypes/uploadDocumentActionTypes"

export interface UploadDetailsState {
  institutionName: string;
  fileList: Array<string>;
  passwordFlag: boolean;
}
export interface UploadDocumentState {
  institutionList: Array<IInstitutionListResponse>;
  uploadDocumentResponse: Array<ISuccessResponseType>;
  uploadDocumentCompleted: boolean;
  initiateResponse: string;
  uploadDetailsResponse: UploadDetailsState;
  resumeJourneyResponse: boolean;
}

const initialState: UploadDocumentState = {
  institutionList: [],
  uploadDocumentResponse: [],
  initiateResponse: "",
  uploadDocumentCompleted: false,
  uploadDetailsResponse: {
    institutionName: "",
    fileList: [],
    passwordFlag: false
  },
  resumeJourneyResponse: false,
}

export const UploadDocumentReducer = (
  state: UploadDocumentState = initialState,
  action: uploadDocumentActions.UploadDocumentActions
): UploadDocumentState => {
  switch (action.type) {
    case uploadDocumentActions.GET_INSTITUTION_LIST_SUCCESS:
      return {
        ...state,
        institutionList: action.institutionList
      };
    case uploadDocumentActions.INITIATE_UPLOAD_DOC_SUCCESS:
      return {
        ...state,
        initiateResponse: action.initiateResponse
      };
    case uploadDocumentActions.UPLOAD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        uploadDocumentResponse: action.uploadDocumentResponse,
        uploadDocumentCompleted: true
      };
    case uploadDocumentActions.UPLOAD_DETAILS_SUCCESS:
      return {
        ...state,
        uploadDetailsResponse: {
          institutionName: action.institutionName,
          fileList: action.fileList,
          passwordFlag: action.passwordFlag
        }
      };
    case uploadDocumentActions.RESUME_JOURNEY_SUCCESS:
      return {
        ...state,
        resumeJourneyResponse: action.resumeJourneyResponse
      };
    case uploadDocumentActions.UPLOAD_DOCUMENTS_RESET:
      return {
        ...state,
        initiateResponse: "",
        uploadDocumentCompleted: false
      };
    default:
      return state
  }
}